import React, { useState } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

import Header from "./Header";
import Footer from "./Footer";
import ThemeContext from "../context/ThemeContext";
import '../styles/index.scss';
import appTheme from './Theme';

const Layout = ({ children }) => {
  const [themeHook, setThemeHook] = useState("light");
  const windowGlobal = typeof window !== 'undefined' && window;
  let theme = "light";

  try {
    theme = windowGlobal.localStorage.getItem("neumTheme")
  } catch {
    
  }
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <ThemeContext.Provider value={[themeHook, setThemeHook]}>
        <Header siteTitle={data.site.siteMetadata.title} />
        <div style={appTheme[theme]} className="container">
          <main className="container-main">{children}</main>
          <Footer siteTitle={data.site.siteMetadata.title} />
        </div>
      </ThemeContext.Provider>
    </>
  )
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout;
